import init from 'cape-react-app'
import initialState from './initState'
import * as RouteIndex from './components/RouteIndex'
import './index.css'
// const { store, firebase } =
init(initialState, RouteIndex)



// WEBPACK FOOTER //
// ./src/index.js